<template>
  <div class='technology-name-table-cell' :title='fullTechnologyName' @click='() => { $emit("click") }'>
    {{ fullTechnologyName }}
  </div>
</template>

<script>
import { specialTechNames } from '@/constants/technologies';

export default {
  name: 'TechnologyNameTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    allTechNameParts() {
      return this.item[this.category.field].split('/');
    },
    techName() {
      return Object.keys(specialTechNames).includes(this.allTechNameParts[0].toLowerCase()) ? specialTechNames[this.allTechNameParts[0].toLowerCase()] : this.allTechNameParts[0];
    },
    fullTechnologyName() {
      const version = this.allTechNameParts.length > 1 ? this.allTechNameParts[1] : '';
      return `${this.techName} ${version}`;
    },
  },
};
</script>

<style lang='scss' scoped>
.technology-name-table-cell {
  width: inherit;
  max-width: calc(100% - 30px);
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
